import {DiseaseParametersModel} from "@/entities/diseaseParameters/DiseaseParametersModel";

export class Branch {
    id: number;
    name: string;
    model: DiseaseParametersModel;
    departmentType?: string;

    constructor(id: number, name: string, model: DiseaseParametersModel,departmentType?: string)  {
        this.id = id;
        this.name = name;
        this.model = model;
        this.departmentType = departmentType;
    }
}
